export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9972.77289a18.jpg";